export const isArray = o => {
	return Object.prototype.toString.call(o) === '[object Array]';
};
export const isObject = o => {
	return Object.prototype.toString.call(o) === '[object Object]';
};
export const isFunction = o => {
	return (
		Object.prototype.toString.call(o) === '[object Function]' ||
		Object.prototype.toString.call(o) === '[object AsyncFunction]'
	);
};
export const isString = o => {
	return Object.prototype.toString.call(o) === '[object String]';
};
export const isNumber = o => {
	return Object.prototype.toString.call(o) === '[object Number]';
};
export const isBoolean = o => {
	return Object.prototype.toString.call(o) === '[object Boolean]';
};
export const isDate = o => {
	return Object.prototype.toString.call(o) === '[object Date]';
};
export const isNull = o => {
	return Object.prototype.toString.call(o) === '[object Null]';
};
export const isUndefined = o => {
	return Object.prototype.toString.call(o) === '[object Undefined]';
};

export const get100vh = () => {
	return `${window.innerHeight || document.documentElement.clientHeight}px`;
};

// 空函数
export function noop() {}

/**
 * 深度克隆
 */
export const deepClone = obj => {
	if (typeof obj !== 'object' || obj === null) {
		return obj;
	}
	let res;
	if (obj instanceof Array) {
		res = [];
	} else {
		res = {};
	}
	for (let key in obj) {
		if (Object.prototype.hasOwnProperty.call(obj, key)) {
			res[key] = deepClone(obj[key]);
		}
	}
	return res;
};

/** 获取随机数 */
export const getUuid = (radix, len = 8) => {
	var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	let uuid = [];
	let i;
	radix = radix || chars.length;
	if (len) {
		for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
	} else {
		let r;
		uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
		uuid[14] = '4';
		for (i = 0; i < 36; i++) {
			if (!uuid[i]) {
				r = 0 | (Math.random() * 16);
				uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
			}
		}
	}
	return uuid.join('');
};

export const debounce = (func, wait = 300, immediate = false) => {
	var timeout;
	return function () {
		var context = this,
			args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

export const throttle = (func, delay = 300) => {
	let lastCall = 0;
	return function () {
		let now = Date.now();
		if (now - lastCall < delay) {
			return;
		}
		lastCall = now;
		return func.apply(this, arguments);
	};
};
